import { CHECK_BALANCE, COMBINE_CARDS } from '@/constatns';

export default {
    left: [
        {
            routeName: 'retailers',
            displayName: 'Store locator',
        },
        {
            routeName: 'partners',
            displayName: 'Eligible games',
        },
    ],
    cart: {
        routeName: 'card',
        displayName: 'Card',
    },
    manage: [
        {
            routeName: 'card-balance',
            displayName: CHECK_BALANCE,
        },
        {
            routeName: 'card-combine',
            displayName: COMBINE_CARDS,
        },
    ],
    support: {
        routeName: 'support',
        displayName: 'Support',
    },
    right: [
        {
            routeName: 'contact',
            displayNameLong: 'Business inquiries',
            displayNameShort: 'Business',
        },
    ],
};
